import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';

import Cache from './Cache';

import RelatorioService from '../../services/Relatorio';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Toast from '../../components/Toast/Toast';
import Filters from '../../components/Filters/Filters';
import Loading from '../../components/Loading/Loading';
import SelectOption from '../../components/Inputs/Select/Select';
import Legenda from '../../components/Legenda/Legenda';

import DadosCertificados from '../../forms/Relatorio/DadosCertificados';
import EscolaFilter from '../../forms/Escola/EscolaFilterFields';
import EnderecoFilter from '../../forms/Endereco/EnderecoFilter';
import DependenciaAdministrativaFilter from '../../forms/DependenciaAdministrativa/DependenciaAdministrativaFilter';
import { ButtonExport } from '../../forms/Buttons/ButtonsExport';

import AuthorizedElement from '../../security/AuthorizedElement';
import { __RELATORIO_MEDALHAS_EXPORTAR } from '../../security/RoleConfiguration';

import { download } from '../../helper/FileHelper';

import { optionsModalidade } from '../../variables/Enums/Escola';

import { Layout } from '../../layouts/private/Private';

export class Certificados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        modalidade: '',
      },
      ultimaChamada: '',
      loading: true,
      schools: [],
    }
  }

  // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
  setToast = t => this.Toast = t;
  setEscolaFilter = form => this.EscolaFilter = form;
  setEnderecoFilter = f => this.EnderecoFilter = f;
  setDependenciaAdministrativaFilter = d => this.DependenciaAdministrativaFilter = d;

  // INPUTS
  handleChange = e => {
    this.setState({
      filters: {...this.state.filters,  [e.target.name]: e.target.value }
    });
  };

  // FILTROS
  ApplyFilters = () => {
    this.setState({ loading: true });

    const f = [];
    const { filters } = this.state;
    const filtersEscola = this.EscolaFilter.state.filters;
    const filtersEndereco = this.EnderecoFilter.state.filters;
    const filtersDepAdm = this.DependenciaAdministrativaFilter.state.filters;

    if (filtersEscola.inepSchool) f.push({ field: 'cdEscola', value: filtersEscola.inepSchool })
    if (filtersEndereco.UF) f.push({ field: 'cdUf', value: filtersEndereco.UF })
    if (filtersEndereco.region) f.push({ field: 'cdRegiao', value: filtersEndereco.region })
    if (filtersEndereco.city) f.push({ field: 'cdMunicipio', value: filtersEndereco.city })
    if (filtersDepAdm.adminDep) f.push({ field: 'nmDependenciaAdministrativa', value: filtersDepAdm.adminDep })
    if (filters.modalidade) f.push({ field: 'modalidade', value: filters.modalidade })

    f.push({ field: 'forceRefresh', value: true });

    RelatorioService.filtersReportCertificados(f)
      .then(res => {
        this.setState({ 
          ultimaChamada: res.data.ultimaChamada,
          loading: false,
          schools: [ ...res.data.cache ]
        });
      })
      .catch(error => {
        this.setState({ loading: false });
      })
  }

  // EXPORTAÇÃO
  handleExportChange = () => {
    const f = [];
    const { filters } = this.state;
    const filtersEscola = this.EscolaFilter.state.filters;
    const filtersEndereco = this.EnderecoFilter.state.filters;
    const filtersDepAdm = this.DependenciaAdministrativaFilter.state.filters;

    if (filtersEscola.inepSchool) f.push({ field: 'cdEscola', value: filtersEscola.inepSchool })
    if (filtersEndereco.UF) f.push({ field: 'cdUf', value: filtersEndereco.UF })
    if (filtersEndereco.region) f.push({ field: 'cdRegiao', value: filtersEndereco.region })
    if (filtersEndereco.city) f.push({ field: 'cdMunicipio', value: filtersEndereco.city })
    if (filtersDepAdm.adminDep) f.push({ field: 'nmDependenciaAdministrativa', value: filtersDepAdm.adminDep })
    if (filters.modalidade) f.push({ field: 'modalidade', value: filters.modalidade })

    f.push({ field: 'forceRefresh', value: true });
    f.push({ field: 'exportarPlanilha', value: true });

    this.Toast.setState({
      message: {
        message: "A Planilha está sendo gerada para Exportação.",
        type: 'info',
        open: true,
        loading: true,
        autoHide: false,
      }
    })

    RelatorioService.exportReportCertificados(f)
      .then(res => download(res))
  }

  buscarEscolas = (forceRefresh = false) => {
    this.setState({ loading: true });
    const filters = [{ 'field': "forceRefresh", 'value': forceRefresh }];

    RelatorioService.filtersReportCertificados(filters)
      .then(res => {        
        this.setState({ 
          ultimaChamada: res.data.ultimaChamada,
          loading: false,
          schools: [ ...res.data.cache ]
        });   
      })
      .catch(error => {
        const e = errors(error);
        this.setState({ loading: false });

        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      });
  }

  componentDidMount() { 
    this.buscarEscolas();
  }

  // LIMPAR FILTROS
  handleFilterClear = () => {
    this.EscolaFilter.setState({
      filters: {
        inepSchool: '',
      }
    })

    this.EnderecoFilter.setState({
      filters: {
        UF: '',
        region: '',
        city: '',
      }
    })

    this.DependenciaAdministrativaFilter.setState({
      filters: {
        adminDep: '',
      }
    })

    this.setState({
      ...this.state,
      filters: {
        modalidade: ''
      },
    })
  }

  render() {
    const pageName = 'Certificados';
    const links = [
      {
        path: null,
        name: 'Relatórios'
      }
    ];

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container >
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={pageName} />
          </Grid>
        </Grid>
        <Title>
          {pageName}
          { this.state.ultimaChamada && 
            <Cache ultimaAtualizacao={this.state.ultimaChamada} action={() => this.buscarEscolas(true)} /> 
          }
        </Title>

        <Filters
          handleFilter={this.ApplyFilters}
          handleFilterClear={this.handleFilterClear}
        >
          <Grid item container spacing={3}>
            <EscolaFilter
              parentRef={this.setEscolaFilter}
              disabledEmail={true}
              disabledNameSchool={true}
            />
            <EnderecoFilter
              parentRef={this.setEnderecoFilter}
              withRegion={true}
            />
            <DependenciaAdministrativaFilter
              parentRef={this.setDependenciaAdministrativaFilter}
              withPublicGroup={true}
            />
            <Grid item sm={12} lg={2}>
              <SelectOption
                label="Modalidade"
                name='modalidade'
                value={this.state.filters.modalidade}
                onChange={(e) => this.handleChange(e)}
                options={optionsModalidade}
              />
            </Grid>
          </Grid>
        </Filters>
        <Grid container >
          <AuthorizedElement roles={[__RELATORIO_MEDALHAS_EXPORTAR]}>
            <ButtonExport
              title="Exportar Planilha"
              onClick={this.handleExportChange}
            />
          </AuthorizedElement>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: '24px', marginBottom: '-48px' }}>
          <Grid item sm={12} lg={12}>
            <b>Legenda:</b>
            <Legenda params={[ "Mirim 1", "Mirim 2", "Total" ]} />
          </Grid>
        </Grid>

        {this.state.loading ?
          <Loading />
          :
          <DadosCertificados schools={this.state.schools} />
        }
      </Layout>
    )
  }
}

export default withRouter(Certificados);